import { Component, Input } from '@angular/core';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';

@Component({
  selector: 'app-reply-comment-text',
  templateUrl: './reply-comment-text.component.html',
  styleUrls: ['./reply-comment-text.component.scss']
})
export class ReplyCommentTextComponent {
@Input() rcL;
see_more = false;
  constructor(public mls: MultiLangService) { }

  // fulltext() {
  //   if (document.getElementById('fulltextseecmmnt').offsetHeight < document.getElementById('fulltextseecmmnt').scrollHeight) {
  //     document.getElementById('seemoretextcmmnt').style.display = 'block';
  // }
  // }
  // seemoretextcmmnt() {
  //     document.getElementById('fulltextseecmmnt').style.maxHeight = 'none';
  //     document.getElementById('seemoretextcmmnt').style.display ='none';
  // }

seeMore(): void {
  this.see_more = true;
 }

 seeLess(): void {
   this.see_more = false;
  }
}
